import axios from "axios";
import { headers } from "./TokenHeader";
import { Urls } from "./ApiPath";

const findAll = () => {
  return new Promise((resolve, reject) => {
    axios
      .get(`${Urls.drugBanner.v3.findAll}`, { headers: headers })
      .then((response) => {
        resolve(response.data);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

const save = (data, onUploadProgress) => {
  return new Promise((resolve, reject) => {
    let formData = new FormData();
    formData.append("image", data.image);
    formData.append("type", data.type);
    axios
      .post(Urls.drugBanner.v3.save, formData, {
        headers: headers,
        onUploadProgress,
      })
      .then((response) => {
        resolve(response.data);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

const deleteOne = (data) => {
  console.log("data", data);
  return new Promise((resolve, reject) => {
    axios
      .delete(`${Urls.drugBanner.v3.delete}/${data.id}`, { headers: headers })
      .then((response) => {
        resolve(response.data);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

export const DrugBannerService = {
  findAll: findAll,
  save: save,
  deleteOne: deleteOne,
};
